import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserService } from '../services/user.service';

@Injectable()
export class AdminGuard implements CanActivate {
  constructor(private router: Router, private userSvc: UserService) {

  }

  canActivate() {
    if (this.userSvc.isAdmin) {
      return true;
    } else {
      this.router.navigate(['/']);
      return false;
    }
  }


}

